// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-text-field_placeholder__ZuDWL {\n  color: var(--gray-40);\n}\n", "",{"version":3,"sources":["webpack://./src/components/molecules/tasks/details/task-fields/editable-cell/input-text-field/input-text-field.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB","sourcesContent":[".placeholder {\n  color: var(--gray-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": "input-text-field_placeholder__ZuDWL"
};
export default ___CSS_LOADER_EXPORT___;
